export default __webpack_public_path__ + "static/media/newBalance.3e556368.svg";